import React, { useEffect, useState } from 'react';
import { BRAND } from '../config/brand.js';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setVisible(false);
    setDeferredPrompt(null);
  };

  const dismiss = () => setVisible(false);

  if (!visible) return null;

  return (
    <div
      className="install-prompt d-flex align-items-center gap-3 px-3 py-2"
      role="banner"
      aria-label="Install app"
    >
      <i className="fa-solid fa-mobile-screen-button fs-4 text-white" aria-hidden="true" />
      <div className="flex-grow-1">
        <p className="mb-0 text-white fw-semibold small">Add {BRAND.shortName} to your home screen</p>
      </div>
      <button
        type="button"
        className="btn btn-light btn-sm fw-semibold"
        onClick={install}
      >
        Install
      </button>
      <button
        type="button"
        className="btn btn-link text-white p-0 border-0"
        aria-label="Dismiss"
        onClick={dismiss}
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
}
